import './bidding-keyboard-component.scss';
import { Bid, BidComponentProps } from '../../app/types';
// eslint-disable-next-line import/no-unresolved
import { ReactDOMAttributes } from '@use-gesture/react/dist/declarations/src/types';
import { SharkBidComponent } from '../shark-bid-component/shark-bid-component';
import { bridgeWarGui } from '../../env';
import { callComparison } from '../../utils/mixed';
import { convertStringToBid } from '../../app-interfaces/shark-game-engine-helper';
import { engineMakeBid } from '../../app-interfaces/actions/engineCommands';
import { isMobile } from 'react-device-detect';
import { outputActions } from '../../slices/outputSlice';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { useGesture } from '@use-gesture/react';
import { useTranslation } from 'react-i18next';
import React, { FC, FunctionComponent, useRef, useState } from 'react';

export const BiddingKeyboardComponent: FunctionComponent = () => {
    const { t } = useTranslation();
    const [selectedBid, setSelectedBid] = useState<Bid | undefined>(undefined);
    const [alert, setAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState<string | undefined>(undefined);


    const { biddingLadder } = useAppSelector((state) => state.table);
    const {
        sharkLayout: { selectedCardSet },
        sharkSettings,
    } = useAppSelector((state) => state.app);
    const dispatch = useAppDispatch();


    const makeCall = (bid: Bid) => () => {
        if ((alert || sharkSettings.interactionBid === 'confirm') && selectedBid?.call !== bid.call) {
            setSelectedBid(bid);
        } else if (sharkSettings.interactionBid === 'instant' || selectedBid?.call === bid.call) {
            dispatch(engineMakeBid(bid));
            setSelectedBid(undefined);
            setAlertMessage(undefined);
            setAlert(false);
        }
    };

    const handleCancel = () => {
        setSelectedBid(undefined);
        setAlertMessage(undefined);
        setAlert(false);
    };

    const validCalls = ['1nt', '1s', '1h', '1d', '1c', '3nt', '3s', '3h', '3d', '3c', '6nt', '6s', '6h', '6d', '6c'];
    const globallyDisabled = !biddingLadder.isActive;

    return (
        <section className="BiddingKeyboardComponent">
            <div className="bids">
                {biddingLadder.bids.map((bid) => {
                    const disabledCell = globallyDisabled || callComparison(bid.call, biddingLadder.minimalValidCall) > 0;
                    const props = {
                        className: [
                            `biddingCell`,
                            disabledCell ? 'disabled' : '',
                            selectedBid?.call === bid.call ? 'selected' : '',
                        ].join(' ')
                    };
                    const shouldShow = !bridgeWarGui || validCalls.includes(bid.call);
                    return (
                        shouldShow && (
                            <div key={`biddingCell-${bid.call}`} {...props}>
                                <SharkBidComponent bid={bid} selectedCardSet={selectedCardSet} activeHover={!disabledCell} {...(!disabledCell && { makeCall })}/>
                            </div>
                        )
                    );
                })}
            </div>
            <BiddingActions
                globallyDisabled={globallyDisabled}
                selectedBid={selectedBid}
                makeCall={makeCall}
                alert={alert}
            />
            {(alert || sharkSettings.interactionBid === 'confirm') && !!selectedBid && (
                <div className="selectedBid">
                    <SharkBidComponent bid={selectedBid} selectedCardSet={selectedCardSet} />
                    <div className="confirmCancel">
                        <button className="cancel" onClick={handleCancel} />
                        <button className="confirm" onClick={makeCall(selectedBid)} />
                    </div>
                    {alert && (
                        <div className="alertMessage">
                            <label>{t('biddingBox.alertMessage')}</label>
                            <input type="text" value={alertMessage} onChange={(e) => setAlertMessage(e.target.value)} />
                        </div>
                    )}
                </div>
            )}
        </section>
    );
};

const BiddingActions: FC<{
    globallyDisabled: boolean;
    selectedBid: Bid;
    makeCall: (bid: Bid) => () => void;
    alert: boolean;
    alertMessage?: string;
}> = ({ globallyDisabled, selectedBid, makeCall, alert, alertMessage }) => {
    if (bridgeWarGui) {
        return <div className="biddingActions"></div>;
    }
    const {
        sharkLayout: { selectedCardSet },
    } = useAppSelector((state) => state.app);
    const { biddingLadder } = useAppSelector((state) => state.table);
    const { stake, pass, isActive } = biddingLadder;
    const stakes: BidComponentProps[] = [
        {
            bid: {
                call: stake.call,
                backgroundColor: stake.backgroundColor,
                alertMessage,
            },
            isDisabled: Boolean(stake.disabled),
            isActive
        },
        {
            bid: {
                call: 'pass',
                backgroundColor: pass.backgroundColor,
                alertMessage,
            },
            isDisabled: Boolean(pass.disabled),
            isActive
        },
        // {
        //     bid: {
        //         call: 'auctionAlert',
        //         backgroundColor: pass.backgroundColor,
        //         alertMessage,
        //     },
        //     isDisabled: Boolean(pass.disabled),
        //     isActive
        // },
    ];

    const style = {
        '--actions': stakes.length,
    } as React.CSSProperties;

    return (
        <div className="biddingActions" style={style}>
            {stakes.map((stake) => {
                const actionDisabled = globallyDisabled;
                const props = {
                    className: [
                        `biddingCell`,
                        actionDisabled ? 'disabled' : '',
                        stake.bid.call,
                        selectedBid?.call === stake.bid.call ? 'selected' : '',
                        // stake.bid.call === 'auctionAlert' && alert ? 'highlighted' : '',
                    ].join(' ')
                };
                return (
                    <div key={stake.bid.call} {...props}>
                        <SharkBidComponent bid={stake.bid} selectedCardSet={selectedCardSet} activeHover={!actionDisabled} {...(!actionDisabled && { makeCall })}/>
                    </div>
                );
            })}
        </div>
    );
};

export default BiddingKeyboardComponent;
